"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.join.js");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/**
 * -------------------------------
 * @file        store.js
 * @description localStorage存储接口管理
 * @date        2017-09-07
 * -------------------------------
 */

/**
 * @class StoreClass
 * @description 接口数据缓存
 */
var StoreClass = /*#__PURE__*/function () {
  function StoreClass() {
    (0, _classCallCheck2.default)(this, StoreClass);
    this.storage = this._getStorageInstance("localStorage");
    this.supported = this._isSupported();

    if (!this.supported) {
      console.log("不支持localStorage!");
    } else {
      this.clearExpiredCache();
    }
  }
  /**
   * @method _isSupported
   * @private
   * @desc 判断是否支持localStorage功能
   * @return {boolean} true/false
   */


  (0, _createClass2.default)(StoreClass, [{
    key: "_isSupported",
    value: function _isSupported() {
      var supported = false;

      try {
        if (this.storage && this.storage.setItem) {
          supported = true;
          var key = "__" + Math.round(Math.random() * 1e7);

          try {
            this.storage.setItem(key, key);
            this.storage.removeItem(key);
          } catch (err) {
            supported = false;
          }
        }

        return supported;
      } catch (err) {
        console.error(err);
        return false;
      }
    }
    /**
     * @method  _getStorageInstance
     * @private
     * @desc 获取localstorage对象
     * @return {object}
     */

  }, {
    key: "_getStorageInstance",
    value: function _getStorageInstance(storage) {
      try {
        var type = (0, _typeof2.default)(storage);

        if (type === "string" && typeof window !== "undefined" && window[storage]) {
          return window[storage];
        }

        return storage;
      } catch (err) {
        console.error(err);
        return false;
      }
    }
    /**
     * @method  setCache
     * @public
     * @desc 设置localstorage的值
     * @param {string} key 键
     * @param {object} data 需要保存的值
     * @param {number} expires 过期时间(毫秒)
     * @return {object}
     */

  }, {
    key: "setCache",
    value: function setCache(key) {
      var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var expires = arguments.length > 2 ? arguments[2] : undefined;

      if (this.supported) {
        try {
          var cache = this.getCache(key);
          var curTime = new Date().getTime(); // 缓存存在，数据存在，数据没变化，过期时间没变化

          if (cache && cache.data && cache.data === result.data && expires && cache.expires && cache.preExpires && +cache.preExpires === expires) {
            console.log("缓存无更新");
            result.expires = cache.expires;
            result.preExpires = cache.preExpires;
          } else if (expires) {
            console.log("更新缓存");
            result.expires = curTime + expires * 1000;
            result.preExpires = expires;
          }

          this.storage.setItem(key, JSON.stringify(result));
        } catch (err) {
          console.error(err);
        }
      } else {
        console.log("不支持localStorage!");
      }
    }
    /**
     * @method  getCache
     * @public
     * @desc 获取localstorage的值
     * @param {string} key 键
     * @return {object}
     */

  }, {
    key: "getCache",
    value: function getCache(key) {
      if (this.supported) {
        try {
          var cache = JSON.parse(this.storage.getItem(key));
          var time = new Date().getTime();

          if (cache) {
            if (cache.expires && cache.expires > time || !cache.expires) {
              return cache;
            } else {
              this.storage.removeItem(key);
              return null;
            }
          } else {
            return null;
          }
        } catch (err) {
          console.error(err);
          return null;
        }
      } else {
        console.log("不支持localStorage!");
      }
    }
    /**
     * @method  clearExpiredCache
     * @public
     * @desc 清理一遍所有的过期缓存
     * @return {void}
     */

  }, {
    key: "clearExpiredCache",
    value: function clearExpiredCache() {
      var curTime = new Date().getTime();

      for (var key in this.storage) {
        try {
          var cache = JSON.parse(this.storage.getItem(key));

          if (cache.data && cache.ajax) {
            // 判断是api-cache
            if (!cache.expires || cache.expires && cache.expires < curTime) {
              this.storage.removeItem(key);
            }
          }
        } catch (e) {// return
        }
      }
    }
    /**
     * @method getKey
     * @public
     * @desc 根据url及参数拼装key
     * @param {string} url
     * @param {object} params
     * @return {string}
     */

  }, {
    key: "getKey",
    value: function getKey(url, params) {
      var _params;

      if ((_params = params) !== null && _params !== void 0 && _params.params) {
        var _params2;

        params = (_params2 = params) === null || _params2 === void 0 ? void 0 : _params2.params;
      }

      var arr = [];

      if (params) {
        for (var p in params) {
          arr.push(p + "=" + params[p]);
        }
      }

      return url + (arr.length ? (url.indexOf("?") > 0 ? "&" : "?") + arr.join("&") : "");
    }
  }]);
  return StoreClass;
}();

var _default = StoreClass;
exports.default = _default;